/**
 * it is a reusable duplication of the verification component in "../workspace/verification.js"
 * the logic is same, it will be useful for reset password, signup, and invitation accept
 * The code is duplicated again and again.
 * So, we need to fix that. I wrote this file to reuse.
 */

import React, { useState, useEffect } from "react";
import { Loader } from "./loader/loader";

export default function(props) {
  const [isLoading, setLoading] = useState({ showLoader: true, error: false });
  const verify = props.verify || (() => Promise.resolve());
  const loadingText = props.loadingText;
  const loadingExtraMsg = props.loadingExtraMsg;

  useEffect(() => {
    verify()
      .then(() => {
        setLoading({ showLoader: false, error: false });
      })
      .catch(err => {
        setLoading({ showLoader: false, error: true });
      });
    setLoading({ showLoader: true, error: false });
  }, []);

  return isLoading.showLoader ? (
    <Loader.PageLoader
      show={true}
      loadingText={loadingText}
      extraMsg={loadingExtraMsg}
    />
  ) : isLoading.error ? (
    props.ErrorPage
  ) : (
    props.SuccessPage
  );
}
